"use strict";

(function () {
    // aos init
    if (document.querySelectorAll("[data-aos]").length > 0) {
        AOS.init({
            once: true,
            startEvent: "load",
            delay: 300,
            duration: 1500,
            offset: 10,
        });
    }

    // 마우스 오버 시 비디오 재생, 벗어나면 멈춤
    const videoList = document.querySelectorAll(".video");
    let isTouchEnable = null;

    videoInit();
    videoUpdate();

    window.addEventListener("resize", function () {
        videoUpdate();
    });

    function videoInit() {
        videoList.forEach((video) => {
            video.addEventListener("mouseover", function () {
                if (!isTouchEnable) {
                    playVideo(video);
                }
            });

            const io = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    let target = entry.target;
                    if (isTouchEnable) {
                        if (entry.intersectionRatio > 0) {
                            playVideo(target);
                        } else {
                            target.pause();
                        }
                    }
                });
            });
            io.observe(video);
        });
    }

    function videoUpdate() {
        isTouchEnable =
            "ontouchstart" in window ||
            navigator.maxTouchPoints > 0 ||
            navigator.msMaxTouchPoints > 0;

        videoList.forEach((video) => {
            if (!isTouchEnable) {
                video.pause();
            } else {
                playVideo(video);
            }
        });
    }

    function playVideo(video) {
        if (video.paused && videoCanPlay(video)) {
            video.play();
        }
    }

    //재생 가능한 비디오 구분
    function videoCanPlay(video) {
        return new Promise(function (resolve) {
            video.addEventListener("canplay", function () {
                resolve(true);
            });
        });
    }
})();